import * as React from 'react';
import {Link} from 'react-router';

declare const require: any;
const $: any = require('jquery');

export class Accounting extends React.Component<{}, {code: string, data: any[]}> {
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            data: []
        }
    }
    
    private find(e) {
        const code = e.target.value;
        this.setState({code, data: []});
        $.getJSON('/reg/find', {code, r: Math.random()}, data => {
            this.setState({code, data});
        });
    }
    
    private register(item) {
        item.registered = new Date().toISOString();
        $.post(`/reg/user/update?id=${item._id}`, {registered: new Date().toISOString()}, (response) => {
            if (response === true) {
                this.setState({code: this.state.code, data: this.state.data});
            } else {
                alert(response.error);
            }
        }, 'json');
    }
    
    private getType(type: string, item: any) {
        switch (type) {
            case 'sony':
                return 'VIP Sony' + (item.gift ? ' + подарок' : '');
            case 'user':
                return 'Посетитель';
            case 'brand':
                return 'Участник';
            case 'partner':
                return 'Партнер';
        }
    }
    
    public render() {
        return (
            <div className="dashboard">
                <Link className="back" to="/dashboard">Вернуться в панель управления</Link>
                <h1>Регистрация участников конференции LOUDHEAD 2016</h1>
                <form>
                    <input autoComplete="off" autoFocus={true} placeholder="Введите номер билета" type="text" name="code" value={this.state.code} onChange={e => this.find(e)} />
                </form>
                <table>
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Тип</th>
                        <th>Имя</th>
                        <th>Email</th>
                        <th>Телефон</th>
                        <th>Зарегистрирован</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.data.length === 5 && (
                        <tr>
                            <td colSpan={6}>Показано 5 совпадений. Уточните запрос, чтобы получить нужный результат.</td>
                        </tr>
                    )}
                    {this.state.data.map(
                        item => (
                            <tr key={item._id}>
                                <td>
                                    <b style={{fontSize: '150%'}}>{parseInt(item._id.substr(-5), 16)}</b><br/>
                                    {item.registered
                                        ? <div>Зарегистрирован:<br/>{new Date(item.registered).toLocaleString()}</div>
                                        : <button onClick={e => this.register(item)}>Регистрация</button>
                                    }
                                </td>
                                <td>{this.getType(item.type, item)}</td>
                                <td>{item.name} {item.lastName}</td>
                                <td>{item.email}</td>
                                <td>{item.phone}</td>
                                <td>{item.date && new Date(item.date).toLocaleString()}</td>
                            </tr>
                        )
                    )}
                    {this.state.data.length === 0 && (
                        <tr>
                            <td colSpan={6}>{this.state.code ? 'Ничего не найдено' : 'Нет данных для поиска'}</td>
                        </tr>
                    )}
                    </tbody>
                </table>
                <br />
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Dashboard/Accounting.tsx
 **/